var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_3594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2915 15.1766V19.0416C7.2915 19.3116 7.46484 19.5508 7.7215 19.6358C7.78567 19.6566 7.8515 19.6666 7.9165 19.6666C8.1115 19.6666 8.29984 19.575 8.41984 19.4116L10.6807 16.335L7.2915 15.1766Z",
    fill: "#F77E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7376 0.615785C19.5459 0.479952 19.2942 0.461618 19.0859 0.570785L0.335871 10.3624C0.114204 10.4783 -0.0166296 10.7149 0.00170373 10.9641C0.0208704 11.2141 0.186704 11.4274 0.422537 11.5083L5.63504 13.2899L16.7359 3.79828L8.14588 14.1474L16.8817 17.1333C16.9467 17.1549 17.015 17.1666 17.0834 17.1666C17.1967 17.1666 17.3092 17.1358 17.4084 17.0758C17.5667 16.9791 17.6742 16.8166 17.7017 16.6341L19.9934 1.21745C20.0276 0.984118 19.9292 0.752452 19.7376 0.615785Z",
    fill: "#F77E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_3594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/PaperPlane.c07dc595a09829b997e01924bed97b7e.svg";
export { ForwardRef as ReactComponent };